import SuccessIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import { CircularProgress } from "@mui/material";
import Notification from "rc-notification";
import * as React from "react";

const textStyle: any = {
    paddingLeft: 10,
    height: 25,
    lineHeight: "25px",
};

let notification: any = null;

Notification.newInstance({}, (n) => notification = n);

export namespace PopupMessage {
    export function success(text: string) {
        if (notification) {
            notification.notice({
                content: <span style={{ display: "flex" }}>
                    <SuccessIcon style={{ color: "green" }}/>
                    <span style={textStyle}>{text}</span>
                </span>,
                duration: 3,
            });
        }
    }

    export function error(text: string, duration = 5, errorObject: Error = null) {
        if (notification) {
            if (errorObject) {
                console.log(errorObject);
            }

            notification.notice({
                content: <span style={{ display: "flex" }}>
                    <ErrorIcon style={{ color: "red" }}/>
                    <span style={textStyle}>
                        {text}
                    </span>
                </span>,
                duration,
            });
        }
    }

    export function loading(text: string) {
        if (notification) {
            const key = Date.now();

            notification.notice({
                content: <span style={{ display: "flex" }}>
                    <CircularProgress style={{ width: 23, height: 23 }}/>
                    <span style={textStyle}>{text}</span>
                </span>,
                duration: 0,
                key,
            });

            return (cb?) => {
                notification.removeNotice(key);

                if (cb) {
                    cb();
                }
            };
        }

        return (cb) => {
            cb();
        };
    }
}
